<script setup lang="ts">
import type {NuxtError} from '#app';

const props = defineProps({
    error: {
        type: Object as () => NuxtError,
        required: true,
    },
});

const {
    showStatusCode,
    errorTitle,
    errorDescription,
    handleBackToHomeClick,
} = usePageNotFound(props.error);
</script>

<template>
    <section class="error-page">
        <div class="container">
            <div class="error-page__content" data-aos="fade-up" data-aos-duration="1000">
            <span v-if="showStatusCode" class="error-page__code">
                {{ error.status }}
            </span>

                <h1 class="error-page__title">
                    {{ errorTitle }}
                </h1>

                <p class="error-page__text">
                    {{ errorDescription }}
                </p>

                <NuxtLink
                    to="/"
                    class="error-page__link"
                    @click="handleBackToHomeClick"
                >
                    Вернуться на главную
                </NuxtLink>
            </div>
        </div>

    </section>
</template>

<style scoped lang="scss">
@import "styles/page-not-found.scss";
</style>
